<template>
   <div class="container mt-5">
      <div class="row mt-5">
        <div class="col m-auto mb-4 box d-flex justify-content-center">
          <h1 class="heading">
            A Local <span id="IO">Celebration of Tech </span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col m-auto partners-img d-flex justify-content-center">
          <img src="../../assets/partners.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>